import { Component, inject, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {MerchantService} from '../../../../_services/merchant.service';

@Component({
    selector: 'app-prod-transactions-summary',
    templateUrl: './prod-transactions-summary.component.html',
    styleUrls: ['./prod-transactions-summary.component.scss'],
    standalone: false
})
export class ProdTransactionsSummaryComponent implements OnInit {
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly router: Router = inject(Router);

  ngOnInit(): void {
    if (!this.merchantService.currentProductionMerchant) {
      this.router.navigate(['production/configuration/solutions'], {});
    }
  }

}
